import React from "react";
import PropTypes from "prop-types";
import InlineError from "../messages/InlineError";
import isEmpty from "lodash/isEmpty";

// Semantic UI Components
import { Form, Button, Message, Icon } from "semantic-ui-react";

class ForgotPasswordForm extends React.Component {
  state = {
    data: {
      username: ""
    },
    isLoading: false,
    errors: {}
  };

  onChange = e =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    });

  onSubmit = () => {
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (isEmpty(errors)) {
      this.setState({ isLoading: true });
      this.props.submit(this.state.data).catch(err => {
        if (err.response.status >= 500) {
          this.setState({
            errors: {
              global: "No se pudo contactar con el servidor"
            },
            isLoading: false
          });
        } else {
          this.setState({
            errors: err.response.data.errors,
            isLoading: false
          });
        }
      });
    }
  };

  validate = data => {
    const errors = {};
    if (!data.username) errors.username = "No puede estar en blanco";
    return errors;
  };

  render() {
    const { data, errors, isLoading } = this.state;
    return (
      <Form onSubmit={this.onSubmit} loading={isLoading}>
        {errors.global && (
          <Message icon negative>
            <Icon name="lock" />
            <Message.Content>
              <Message.Header>{errors.global}</Message.Header>
              <p>Por favor, intenta nuevamente.</p>
            </Message.Content>
          </Message>
        )}
        <Form.Field error={!!errors.username}>
          <input
            type="text"
            id="username"
            name="username"
            placeholder="Digite su usuario o documento de identidad para solicitar el cambio de contraseña"
            value={data.username}
            onChange={this.onChange}
          />
          {errors.username && <InlineError text={errors.username} />}
        </Form.Field>
        <Button
          color="blue"
          content="Solicitar cambio"
          icon="sign in"
          labelPosition="left"
        />
      </Form>
    );
  }
}

ForgotPasswordForm.propTypes = {
  submit: PropTypes.func.isRequired
};

export default ForgotPasswordForm;
